<div>
    <canvas id="myChart" class=""></canvas>
</div>